import { Flex, Heading, Button, Box, FormControl, FormLabel, RadioGroup, Radio, Spinner } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import CustomInput from '../../../../components/common/Input/input'
import * as api from '../../../../api/outrasPaginas'
import Swal from 'sweetalert2'
import { Language } from "../../../../language";
import { Carousel } from '../../../../components/Carousel/carousel';
import { templates } from '../../../../components/TemplatePaginas/template-pagina';

function EditarPagina() {
  const { id } = useParams();
  const navigate = useNavigate()
  const [txtHtml, setTxtHtml] = useState('');
  const [siteExterno, setSiteExterno] = useState('0');
  const [isLoading, setIsLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    nomPagina: {
      value: '',
      error: false
    },
    dscUrl: {
      value: '',
      error: false
    },
    txtHtml: {
      value: '',
      error: false
    }
  })

  const fetchObterPagina = async () => {
    setIsLoading(true);
    try {
      const paginasData = await api.obterPagina(Number(id));
      const { nomPagina, dscUrl, txtHtml, numHtmlProprio } = paginasData;

      setFormValues({
        nomPagina: { value: nomPagina, error: false },
        dscUrl: { value: dscUrl || '', error: false },
        txtHtml: { value: txtHtml || '', error: false },
      });

      setTxtHtml(txtHtml || '');
      setSiteExterno(numHtmlProprio ? String(numHtmlProprio) : '0');
    } catch (error) {
      console.error("Erro ao buscar dados da página:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchObterPagina();
  }, []);

  const isFormValid = () => {
    const { nomPagina } = formValues;
    return (
      nomPagina.value &&
      nomPagina.value.trim() &&
      nomPagina.value.length >= 5
    );
  };

  const handleFieldChange = (field: string, value: string) =>
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    })

  const handleSubmit = async () => {
    const { nomPagina } = formValues;
    const { dscUrl } = formValues;

    const formataData = (date: any) => {
      const ano = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const dia = String(date.getDate()).padStart(2, '0');
      return `${ano}-${mes}-${dia}`;
    };

    const params = {
      seqPagina: Number(id),
      nomPagina: nomPagina.value || null,
      datRegistro: formataData(new Date()),
      dscUrl: dscUrl.value || null,
      txtHtml: null,
      numHtmlProprio: 1,
      datInativo: null,
      codModeloPagina: null,
      numBloqueada: 0,
      jsonModelo: null,
      sitRegistro: 1
    };

    try {
      await api.editarPagina(params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Página editada com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    } catch (error) {
      console.error('Erro ao editar página:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar página. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Editar Página
      </Heading>
      {isLoading ? (

        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl isRequired>
                <FormLabel mb="8px">Nome da Página</FormLabel>
                <CustomInput
                  placeholder='Digite um nome'
                  value={formValues.nomPagina.value}
                  onChange={(e) => handleFieldChange('nomPagina', e.target.value)}
                  maxLength={100}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl>
                <FormLabel mb="8px">URL da Página</FormLabel>
                <CustomInput
                  placeholder='Digite uma URL'
                  value={formValues.dscUrl.value}
                  onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                  maxLength={512}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl>
                <FormLabel mb="8px">Site externo</FormLabel>
                <RadioGroup
                  mt={3.5}
                  value={siteExterno}
                  onChange={(value) => setSiteExterno(value)}
                >
                  <Radio value="1" mr={5}>Sim</Radio>
                  <Radio value="0">Não</Radio>
                </RadioGroup>
              </FormControl>
            </div>
            {siteExterno === '0' && (
              <div className="col-md-12 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Escolha um modelo pré-definido</FormLabel>
                  <Carousel items={templates} />
                </FormControl>
              </div>
            )}
          </div>
          <Box alignItems={'flex-end'}>
            <Button type="submit" m="px" onClick={() => navigate(-1)}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit();
              }}
              isDisabled={!isFormValid()}
            >
              Editar Página
            </Button>
          </Box>
        </Box>
      )}

    </Flex>
  )
}

export default EditarPagina;
